export default __webpack_public_path__ + "143ec408e4fa67f3553d83d7f831dde2.webp";